import { config } from '../../../../core/config/config';
import {
  LpBackendError,
  lpRequest,
  refId,
  toBoolean,
  toNumber
} from '../../../../core/utils/lp-backend';
import { TakealotIntegrationSettings } from '../../presentation/redux/types/settings-types';
import { toSettings } from '../repositories/settings-repository-impl';
import { readSettings } from './settings-fields';

/**
 * `PATCH /client/settings/takealot {collection_time_threshold, required_returns_enabled}`, then public-api
 * `POST /v1/contracts/:contract_id/select-hubs {hub_ids}` with the same token. The contract is the client's
 * `integration_flow.contract`, read from `GET /client/user/me` (`GET /client/:cid` does not return it).
 */
export const editTakealotSettings = async (
  takealot_settings: TakealotIntegrationSettings
): Promise<any> => {
  const me = await lpRequest('GET', '/client/user/me');
  const contract_id = refId(me.account?.integration_flow?.contract);
  if (!contract_id) {
    throw new LpBackendError('This account has no Takealot contract to select hubs on.', 404);
  }

  await lpRequest('PATCH', '/client/settings/takealot', {
    body: {
      collection_time_threshold: toNumber(takealot_settings.collection_time_threshold),
      required_returns_enabled: toBoolean(takealot_settings.required_returns_enabled)
    }
  });
  await lpRequest('POST', `/v1/contracts/${contract_id}/select-hubs`, {
    base: config.uri.lp_public_api,
    body: { hub_ids: takealot_settings.hub_ids || [] }
  });

  return toSettings(await readSettings());
};
